import { Checkbox, CheckboxProps } from '@mui/material'
import { molsonStyled } from '@theme/customMuiExports'
import { greenCheckUrl, whiteCheckUrl } from '@utils/constants'
import { FC } from 'react'

export interface MolsonDefaultCheckBoxProps extends CheckboxProps {
  dataTestId?: string
}

export const BaseIcon = molsonStyled('span')(({ theme }) => ({
  borderRadius: 6,
  width: 20,
  height: 20,
  border: `1px solid ${theme.palette.secondary[500]}`,
  'input:disabled ~ &': {
    border: `1px solid ${theme.palette.secondary[300]}`
  }
}))

export const CheckedIcon = molsonStyled(BaseIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.lightest,
  border: `1px solid ${theme.palette.primary.dark}`,
  '&:before': {
    display: 'block',
    width: 20,
    height: 20,
    backgroundImage: greenCheckUrl,
    content: '""'
  },
  'input:disabled ~ &': {
    border: `1px solid ${theme.palette.primary.lightest}`,
    '&:before': {
      backgroundImage: whiteCheckUrl
    }
  }
}))

const IndeterminateIcon = molsonStyled(BaseIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.lightest,
  border: `1px solid ${theme.palette.primary.dark}`,
  '&:before': {
    display: 'block',
    width: 20,
    height: 20,
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='-3 -8 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.25 1.75H0.75V0.25H11.25V1.75Z' fill='%2300948D'/%3E%3C/svg%3E")`,
    content: '""'
  },
  'input:disabled ~ &': {
    border: `1px solid ${theme.palette.primary.lightest}`,
    '&:before': {
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='-3 -8 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.25 1.75H0.75V0.25H11.25V1.75Z' fill='%23FFFFFF'/%3E%3C/svg%3E")`
    }
  }
}))

export const MolsonDefaultCheckbox: FC<MolsonDefaultCheckBoxProps> = ({
  dataTestId,
  ...props
}) => {
  return (
    <Checkbox
      data-testid={dataTestId}
      icon={<BaseIcon />}
      checkedIcon={<CheckedIcon />}
      indeterminateIcon={<IndeterminateIcon />}
      {...props}
    />
  )
}
